import React, { useEffect, useState } from "react";
import RichCard from "./RichCard/RichCard";
import { Card } from "react-bootstrap";
import { connect } from "react-redux";
import { loadTrainings } from "redux/actions/trainingActions";
import { IsNullOrEmptyOrUndefined } from "utils/validatorHelpers";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const labels = ["pn", "wt", "śr", "czw", "pt", "sob", "nd"];

function HomePage({ trainings, userId, loadTrainings, selectedDate }) {
  let kilometersNum = 0;

  const headerStyles = {
    margin: "0px 0px 10px",
    fontFamily: "system-ui",
    fontWeight: "600",
  };

  const cardBodyStyles = {
    display: "flex",
    justifyContent: "space-around",
  };

  const contentStyles = {
    display: "flex",
    justifyContent: "space-around",
    padding: "4px 16px 4px 16px",
    flexWrap: "wrap",
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: `Liczba kilometrów za bieżący tydzień: ${
          calculateWeeksKilometers().accumulator
        }`,
      },
    },
  };

  function calculateWeeksKilometers() {
    const startOfWeek = moment().startOf("week");
    const currentDay = moment();
    const dayOfWeek = currentDay.weekday() + 1;

    let weekObject = {};

    for (let index = 0; index < dayOfWeek; index++) {
      let dateKey = startOfWeek.format("YYYY-MM-DD");
      weekObject[dateKey] = 0;
      startOfWeek.add(1, "day");
    }
    const dataToProcess = [];

    console.log(trainings);

    Object.keys(weekObject).map((key) => {
      dataToProcess.push(
        trainings.filter(
          (item) => item?.start === key && item?.unit === "kilometry"
        )[0]?.kilometers || 0
      );
    });

    const output = [];
    let accumulator = 0;

    dataToProcess?.reduce((prev, acc) => {
      accumulator += prev;
      output.push(accumulator);
      return acc;
    }, 0);

    return { output, accumulator };
  }

  const data = {
    labels,
    datasets: [
      {
        label: "Liczba kilometrów",
        data: calculateWeeksKilometers().output,
        borderColor: "#3472F7",
        backgroundColor: "#3472F7",
      },
    ],
  };

  useEffect(() => {
    if (!IsNullOrEmptyOrUndefined(userId)) {
      loadTrainings(userId).catch((error) => {
        console.log("Wystąpił problem z załadowaniem treningów: " + error);
      });
    }
  }, [userId]);

  return (
    <>
      <div style={contentStyles}>
        <div>
          <h4 style={headerStyles}>Twój plan dnia</h4>
          <Card bg="light">
            <Card.Body style={cardBodyStyles}>
              <RichCard data={trainings} date={selectedDate} />
            </Card.Body>
          </Card>
        </div>
        <div style={{ width: "700px", height: "490px" }}>
          <Line options={options} data={data} />
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    trainings: state.trainings,
    userId: state.user.selectedUser?.userId || state.auth.userId,
    selectedDate: state.core.selectedDate,
  };
}

const mapDispatchToProps = { loadTrainings };

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
